import React from "react";
import { useTranslation } from "react-i18next";
import ClockAreaFooter from "./ClockAreaFooter";

interface CustomTextAreaProps {
  text: string;
  onEdit?: () => void; // 新增可选回调
}

/**
 * 自定义文字区域组件
 */
export const CustomTextArea: React.FC<CustomTextAreaProps> = ({
  text,
  onEdit,
}) => {
  const { t } = useTranslation(["v3/clock"]);

  // if (!text.trim()) {
  //   return (
  //     <div
  //       className="h-full w-full flex items-center justify-center cursor-pointer"
  //       onClick={onEdit}
  //     >
  //       <div className="text-gray-400 dark:text-gray-600 text-center">
  //         <svg
  //           className="w-6 h-6 mx-auto mb-2"
  //           viewBox="0 0 24 24"
  //           fill="none"
  //           xmlns="http://www.w3.org/2000/svg"
  //         >
  //           <path
  //             d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
  //             stroke="currentColor"
  //             strokeWidth="2"
  //             strokeLinecap="round"
  //             strokeLinejoin="round"
  //           />
  //           <polyline
  //             points="14,2 14,8 20,8"
  //             stroke="currentColor"
  //             strokeWidth="2"
  //             strokeLinecap="round"
  //             strokeLinejoin="round"
  //           />
  //           <line
  //             x1="16"
  //             y1="13"
  //             x2="8"
  //             y2="13"
  //             stroke="currentColor"
  //             strokeWidth="2"
  //             strokeLinecap="round"
  //             strokeLinejoin="round"
  //           />
  //           <line
  //             x1="16"
  //             y1="17"
  //             x2="8"
  //             y2="17"
  //             stroke="currentColor"
  //             strokeWidth="2"
  //             strokeLinecap="round"
  //             strokeLinejoin="round"
  //           />
  //           <polyline
  //             points="10,9 9,9 8,9"
  //             stroke="currentColor"
  //             strokeWidth="2"
  //             strokeLinecap="round"
  //             strokeLinejoin="round"
  //           />
  //         </svg>
  //         <div className="text-xs">
  //           {t("v3/clock:components.customText.empty", "点击配置文字")}
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }

  return (
    <div
      className="h-full w-full flex items-center justify-center flex-col cursor-pointer active:opacity-60 transition duration-200"
      onClick={onEdit}
    >
      <div className="w-full text-justify grow h-1 px-[18px] text-[14px] overflow-y-auto">
        <div className="leading-[1.35] break-words flex flex-col justify-center min-h-full pt-[6px]">
          {!text.trim() ? (
            <>
              <div className="fake-cursor"></div>
              <div className="leading-none opacity-35 pl-[2px]">{"点击设置文字…"}</div>
            </>
          ) : (
            text.split("\n").map((line, index) => (
              <div key={index} className="mb-[5px]">
                {line}
              </div>
            ))
          )}
        </div>
      </div>
      <ClockAreaFooter
        text={"文字记录"}
        icon={"📝"}
      />
    </div>
  );
};

export default CustomTextArea;
